import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'trim' })
export class TrimPipe implements PipeTransform {
  public transform(value: any) {
    if (!value) {
      return '';
    }
    if (typeof value !== 'string') {
      return value;
    }
    return value.trim();
  }
}
